import React from 'react';
import { Input, Form, Divider, message, Space, Button } from 'antd';
import { hnrequest } from '@/utils';
import md5 from "js-md5";


const Uapsw = ({ oncpsw }) => {

  const [messageApi, contextHolderdh] = message.useMessage();


  const [cuname] = Form.useForm();
  const [cupsw] = Form.useForm();


  const onFcuname = async () => {
    const res = await hnrequest.post('/c_uname', cuname.getFieldValue())
    messageApi.open({
      type: res.return_code,
      content: res.return_msg,
    })
  }

  const onFcupsw = async () => {
    const res = await hnrequest.post('/c_upsw', { "nupswo": md5((cupsw.getFieldValue().nupswo)), "nupswf": md5((cupsw.getFieldValue().nupswf)), "nupsws": md5((cupsw.getFieldValue().nupsws)) })

    messageApi.open({
      type: res.return_code,
      content: res.return_msg,
    })

    res.return_code === "success" && setTimeout(() => oncpsw(), 2000);
  }





  return (
    <>
      {contextHolderdh}
      <Divider style={{ borderColor: '#7cb305' }}>修改账号</Divider>
      <Form
        name="cuname"
        form={cuname}
        onFinish={onFcuname}
        labelCol={{
          span: 8,
        }}
        wrapperCol={{
          span: 16,
        }}
        style={{
          maxWidth: 400,
        }}

        autoComplete="off"

      >
        <Form.Item
          label="新用户名"
          name="nuname"
          rules={[{ required: true, message: '请输入新用户名！' }]}
        >
          <Space><Input placeholder='请输入新用户名' /><Button type="primary" htmlType="submit">修改用户名</Button></Space>

        </Form.Item>
      </Form>


      <Divider style={{ borderColor: '#7cb305' }}>修改密码</Divider>
      <Form
        name="cupsw"
        form={cupsw}
        onFinish={onFcupsw}
        labelCol={{
          span: 8,
        }}
        wrapperCol={{
          span: 10,
        }}
        style={{
          maxWidth: 600,
          paddingLeft: "50px",
        }}

        autoComplete="off"

      >
        <Form.Item

          label="密码"
          name="nupswo"
          rules={[{ required: true, message: '请输入原密码！' }]}
        >
          <Space><Input.Password placeholder='请输入原密码' /></Space>
        </Form.Item>

        <Form.Item
          label="新密码"
          name="nupswf"
          rules={[{ required: true, message: '请输入新密码！' }]}
        >
          <Space><Input.Password placeholder='请输入新密码' /></Space>
        </Form.Item>

        <Form.Item
          label="确认密码"
          name="nupsws"
          rules={[{ required: true, message: '请确认密码！' }]}
        >
          <Space><Input.Password placeholder='请输入确认密码！' /></Space>
        </Form.Item>


        <Button type="primary" htmlType="submit" block>修改密码</Button>




      </Form>


    </>
  )

}
export default Uapsw